export const GET_USERS_REQUEST = 'GET_ASSIGN_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_ASSIGN_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_ASSIGN_USERS_FAILED';

export const SET_SELECTED_USER = 'SET_ASSIGN_SELECTED_USER';
